<template>

  <div class="app">
    <b-loading :active.sync="isLoading"></b-loading>
    <router-view>
    </router-view>
  </div>

</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    showSpinner() {
      this.isLoading=true
    },
    hideSpinner() {
      this.isLoading=false

    }
  },
  created: function () {

    this.axios.interceptors.request.use(
      conf => {
        this.showSpinner()
        return conf;
      },
      error => {
        this.hideSpinner()
        return Promise.reject(error);
      }
    );
    this.axios.interceptors.response.use(
      response => {
        this.hideSpinner()
        return response;
      },
      error => {

        this.hideSpinner()

        if (!error.response) {
          Util.showDialogError(this,"Error al conectarse al servidor.")
        }
        else{
          console.log(error.response)
          if(error.response.status=='401')
          {
            this.$dialog.alert({
              title: 'Error de sesión',
              message: 'Su sesión ha <b>expirado,</b> por favor vuelva a iniciar sesión.',
              confirmText: 'Login',
              type: 'is-danger',
              hasIcon: true,
              onConfirm: () => this.$router.push({name:'login'})
            })


            return
          }

        }

        return Promise.reject(error);
      }
    );


  },
}
</script>


<style>
  body, html, .app {
    height: 100%;
  }
</style>





// WEBPACK FOOTER //
// src/App.vue